import React from 'react'
import { useLanguage } from '../i18n/useLanguage'

interface LanguageSwitcherProps {
  transparent?: boolean
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ transparent = false }) => {
  const { isZhCN, toggleLanguage } = useLanguage()

  return (
    <button
      onClick={toggleLanguage}
      className={`inline-flex items-center rounded-md px-2 py-1 text-sm font-medium transition-colors ${
        transparent ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
      }`}
    >
      <span
        className={`rounded px-1.5 py-0.5 ${
          isZhCN
            ? 'bg-blue-50 text-blue-600'
            : transparent
              ? 'text-gray-400'
              : 'text-gray-400'
        }`}
      >
        CN
      </span>
      <span className="mx-1">|</span>
      <span
        className={`rounded px-1.5 py-0.5 ${
          !isZhCN
            ? 'bg-blue-50 text-blue-600'
            : transparent
              ? 'text-gray-400'
              : 'text-gray-400'
        }`}
      >
        EN
      </span>
    </button>
  )
}

export default LanguageSwitcher
